import axios from 'axios';
import qs from 'qs';
import {contentProductList, productList} from "./product_list";
import {add2basket} from './basket';
import {loadLoginPopup} from './customer';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import {
  rootUrl,
  ARTICLE_LINK,
  contentCatScrollDelay,
  contentViewportDeviationForFloating,
  contentFloatNumofBoxes,
  ganBots
} from './config';
//import Splide from '@splidejs/splide';
const linkData={};

function isProductLink(url) {
  if (!url || url.indexOf('/') == -1) return false;
  url=url.split('#')[0];
  var parts=url.split('/');
  var ok=(parts.length==7);
  if(ok) ok=(parts[3] != ARTICLE_LINK);
  return ok;
}

function getProductURL(href) {
  if(!href) return null;
  var ok=isProductLink(href);
  if (!ok) return null;
  var seo_url=href.split('?')[0];
  seo_url=seo_url.split('/');
  seo_url=seo_url[seo_url.length-1];
  if(seo_url){
    seo_url=seo_url.split("#")[0];
  }
  return seo_url;
}

function getProductLinks() {
  $(".content-article-text a").each(function (it) {
    let seo_url=getProductURL(this.href);
    if(seo_url){
      linkData[seo_url]={isProduct: true, url: this.href, info: null};
    }
  });
  return linkData;
}

function a2bHandler() {
  if(!$(this).hasClass("disabled")) add2basket(this, $(this).data("pid"),"float");
  else {
    location.href=$(this).closest("div.prod-content").find("div.prod-name a").attr("href");
  }
}

function showBasketlink(href) {
  //console.log(`Link in '${getProductURL(href)}'`);
  var floatHolder=$('.popup-add-basket');
  if(floatHolder.length <= 0) return;
  if(floatHolder.find('.float-product-item').length > 1) return;
  var seo_url=getProductURL(href);
  //console.log(`SEO Url '${seo_url}'`);
  if(!seo_url) return;
  var pInfo=linkData[seo_url];
  //console.log(`pInfo: `,pInfo);
  if (!pInfo) return;
  if (!pInfo.info) return;
  pInfo = pInfo.info;
  //console.log(`pInfo.info: `,pInfo);
  var productEle=floatHolder.find('#p_'+pInfo.product_id);
  if (productEle.length > 0) return;
  if(pInfo.html){
    $(".popup-add-basket button[name='float_add2basket']").off("click", a2bHandler);
    floatHolder.append(pInfo.html);
    $(".popup-add-basket button[name='float_add2basket']").on("click", a2bHandler);
  }
}

function hideBasketlink(href) {
  //console.log(`Link in '${getProductURL(href)}'`);
  var floatHolder=$('.popup-add-basket');
  if(floatHolder.length <= 0) return;
  var seo_url=getProductURL(href);
  //console.log(`SEO Url '${seo_url}'`);
  if(!seo_url) return;
  var pInfo=linkData[seo_url];
  //console.log(`pInfo: `,pInfo);
  if (!pInfo) return;
  if (!pInfo.info) return;
  pInfo = pInfo.info;
  //console.log(`pInfo.info: `,pInfo);
  $('#p_'+pInfo.product_id).remove();
}

function getProductInfo() {
  getProductLinks();
  var params="";
  for (var link in linkData) {
    if(linkData[link].isProduct) {
      params += (params=="")?`seo_url[]=${link}`:`&seo_url[]=${link}`;
    }
  }
  if(params){
    var url=`${rootUrl}/articles/product_info?${params}`;
    axios({url:url,method:'GET'}).then(function(res) {
      if(res && res.data) {
        let data=res.data;
        console.log(data);
        if(data.status && data.prodInfo){
          for(let prop in data.prodInfo)
            linkData[prop].info=data.prodInfo[prop];
        }
      }
    }).catch(function(err){
      console.log(err);
    });
  }
}

function loadAds(id, ele){
  let url=`${rootUrl}/ads?id=${id}`;
  $(ele).html('');
  axios({url:url,method:'GET'}).then(function(res) {
    if(res && res.data) $(ele).replaceWith(res.data.html);
  }).catch(function(err){
    console.log(err);
  });
}

function showAds() {
  $("oliver-ads").each(function(e){
    var id=$(this).attr('id')
    if (id > 0) loadAds(id, this);
  });
}

function loadMoreArticles(para, ele){
  if(para){
    para.page = Number(para.page)+1;
    let url=`${rootUrl}/articles/getmore?${qs.stringify(para)}`;
    axios.get(url).then(function(res) {
      if(res && res.data && res.data.status) {
        if(res.data.html) $(res.data.html).insertAfter($(".article-session.content-article-container>div.content-mainbox:last-child"));
        if(res.data.hasMore && res.data.para) $(ele).attr("data-para",res.data.para);
        else $(ele).remove();
      }
    }).catch(function(err){
      console.log(err);
    });
  }
}

function GanSubscribe(ele) {
  let subsInfo = {
    list: $(ele).data("sub-list"),
    email: $(ele).closest("div.gan-snippet").find("input[name='subscriber_email']").val()
  };
  let url=`${rootUrl}/gan/subscribe`;
  $("div.gan-snippet div.loader").fadeIn(250);
  axios({url:url,method:'POST',data:subsInfo}).then(function(res) {
    $("div.gan-snippet div.loader").fadeOut(250);
    if(res.data && res.data.status){
      $("div.gan-msg").html(res.data.subTxt);
    } else if (!res.data.status && res.data.error)
      $("div.gan-msg").html(res.data.error.msg);
  }).catch(function(err){
    $("div.gan-snippet div.loader").fadeOut(250);
    console.log(err);
  });
}

function subUnsubLabel(ele){
  let subsInfo = {
    label_id: $(ele).data("id"),
    email: $(ele).data("s-email")
  };
  subsInfo.isSub=true;
  if($(ele).hasClass("is-subs")){
    subsInfo.isSub=false;
  }
  console.log(subsInfo);
  let url=`${rootUrl}/articles/label/subunsub`;
  axios({url:url,method:'POST',data:subsInfo}).then(function(res) {
    if(res.data && res.data.status){
      if(subsInfo.isSub) {
        $(ele).addClass("is-subs");
        $(ele).html($(ele).closest("ul.content-list-label").data("following"));
      } else {
        $(ele).removeClass("is-subs");
        $(ele).html($(ele).closest("ul.content-list-label").data("follow"));
      }
      console.log(res.data);
    }
  }).catch(function(err){
    console.log(err);
  });
}

function catMenuWrapperWidth(){
  return $('.content-container .cat-menu-wrapper').outerWidth();
}

function totalMenuItemsWidth(){
  var tw=0;
  $('.content-menu-container.cat-menu .content-menu.item').each(function(){
    tw=tw+Number($(this).outerWidth(true));
  });
  return tw;
}
function scrollItemsLeft(){
  return $('.content-menu-container.cat-menu').scrollLeft();
}

function adjustCategoryScroll(evt){
  $("button.paddle").css({"display":"none"});
  $('.content-menu-container.cat-menu').css({"overflow-x":"auto","overflow-y":"hidden"});
  $('.content-menu-container.cat-menu').css({"padding-left":"0px"});
  $('.content-menu-container.cat-menu').css({"padding-right":"0px"});
  if(catMenuWrapperWidth() <= totalMenuItemsWidth()){
    if(scrollItemsLeft() > 0) {
      $('.content-menu-container.cat-menu').css({"padding-left":"20px"});
      $("button.left-paddle.paddle").css({"display":"block"});
      if((totalMenuItemsWidth()-scrollItemsLeft()) > catMenuWrapperWidth()) {
        $('.content-menu-container.cat-menu').css({"padding-right":"20px"});
        $("button.right-paddle.paddle").css({"display":"block"});
      }
    }else {
      $('.content-menu-container.cat-menu').css({"padding-right":"20px"});
      $("button.right-paddle.paddle").css({"display":"block"});
    }
  }
}

function bindContentPagesEvents(){
  $.fn.isInViewport = function (adjustTop) {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    if (adjustTop) viewportTop = viewportTop + adjustTop;
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
  adjustCategoryScroll();
  $("button.left-paddle.paddle").on("click", function(evt){
    let scrollLeftPos = scrollItemsLeft();
    let scrollDevi = $('.content-menu-container.cat-menu .content-menu.item:first-child').outerWidth(true);
    $('.content-menu-container.cat-menu').animate({scrollLeft:scrollLeftPos-scrollDevi},contentCatScrollDelay);
  });
  $("button.right-paddle.paddle").on("click", function(evt){
    let scrollLeftPos = scrollItemsLeft();
    let scrollDevi = $('.content-menu-container.cat-menu .content-menu.item:first-child').outerWidth(true);
    $('.content-menu-container.cat-menu').animate({scrollLeft:scrollLeftPos+scrollDevi},contentCatScrollDelay);
  });
  $('.content-menu-container.cat-menu').on('scroll', function (evt) {
    adjustCategoryScroll(evt);
    //console.log(`catMenuWrapperWidth() = ${catMenuWrapperWidth()}`);
    //console.log(`totalMenuItemsWidth() = ${totalMenuItemsWidth()}`);
    //console.log(`scrollItemsLeft() = ${scrollItemsLeft()}`);
  });

  $(window).on('resize', function (evt) {
    adjustCategoryScroll(evt);
    //console.log(`Resize: catMenuWrapperWidth() = ${catMenuWrapperWidth()}`);
    //console.log(`Resize: totalMenuItemsWidth() = ${totalMenuItemsWidth()}`);
    //console.log(`Resize: scrollItemsLeft() = ${scrollItemsLeft()}`);
  });

  $(window).on('scroll', function (i) {
    var cnt=0;
    $(".content-article-text a").each(function (it) {
      var ok=isProductLink(this.href);
      if (!ok) return;
      if(cnt==contentFloatNumofBoxes) return;
      if($(this).isInViewport(contentViewportDeviationForFloating)){
        showBasketlink(this.href);
        cnt+=1 ;
      } else {
        hideBasketlink(this.href);
      }
    });
    tippy('.content-articlelabel-container .subs-help', {
      content: $('.content-articlelabel-container .subs-help').data('tooltip-txt'),
    });
  });

  $("button[name='more_articles']").on("click", function(e){
    loadMoreArticles($(this).data("para"),this);
  });
  $("button[name='gan_subscribe_btn']").on("click", function(e){
    GanSubscribe(this);
  });

  $("ul.content-list-label li.content-labelbox a.label-follow").on("click",function(){
    if($(this).data("s-email")) subUnsubLabel(this);
    else loadLoginPopup(this);
  });

  $("button.btn-bookmark").on("click", function(){
    let isLoggedIn = $("button[name='cust_info']").val() != "";
    if (!isLoggedIn) return $("button[name='cust_info']").click();
    let isBookmarked = $(this).attr("data-is-marked");
    if (isBookmarked && isBookmarked == "true") return;
    else bookmarkArticle(this);
  });
}

function bindingContentPopup() {
  $("a.ctpopup_login_link").on("click", function(e){
    $("#contentPopupWrapper").fadeOut(250);
    loadLoginPopup(this);
  });

  $("#contentPopupWrapper .btnRegister").on("click", function(e){
    $("#contentPopupWrapper").fadeOut(250);
    window.open('/wexthuset-info/registrera-medlem-wexthuset-garden-club', '_self');
  });
}

function getLabelIds() {
  let labels = $("ul.content-list-label li.content-labelbox a.label-follow");
  let lbIds=[];
  labels.each(function(idx, lb){
    lbIds.push($(lb).data("id"));
  });
  return lbIds;
}
function updateLabelState(data){
  let lbIds=data.lbIds;
  for(let l in lbIds){
    let $ele=$(`li.content-labelbox a[name='label_${data.lbIds[l].label_id}']`);
    $ele.attr("data-s-email",lbIds[l].email);
    if(lbIds[l].isSub){
      $ele.addClass("is-subs");
      $ele.html($ele.closest("ul.content-list-label").data("following"));
    } else {
      $ele.removeClass("is-subs");
      $ele.html($ele.closest("ul.content-list-label").data("follow"));
    }
  }
}

function contentLabelsMarking(data){
  if(data && data.email){
    let lbIds=getLabelIds();
    if(lbIds.length){
      let url=`${rootUrl}/articles/label/subscription`;
      axios({url:url,method:'POST',data:{email: data.email, ids: lbIds}}).then(function(res) {
        if(res.data && res.data.status){
          updateLabelState(res.data);
        }
      }).catch(function(err){
        console.log(err);
      });
    }
  }
}

function fixImgTitle() {
  let images = $("img.img-responsive");
  images.each(function() {
    if (!$(this).attr("title") && $(this).attr("alt")) {
      $(this).attr("title", $(this).attr("alt"));
    }
  })
}

function subscribeCssAttribute() {
  document.documentElement.style.setProperty("--scrollbar-width", `${window.innerWidth - document.body.offsetWidth}px`);
}

function bookmarkArticle(ele) {
  let articleId = $(ele).data("article-id");
  articleId = isNaN(articleId)?0:Number(articleId);
  let url = `${rootUrl}/customer/bookmark`;
  axios({url:url,method:'POST',data:{articleId: articleId}}).then(function(res) {
    if (res.data && res.data.status) {
      $("button.btn-bookmark").attr("data-is-marked", true);
      $("button.btn-bookmark").addClass("marked");
      $("button.btn-bookmark").children("span.txt").text($(ele).data("bookmarked-txt"))
    }
    if (res.data && res.data.message) console.log(res.data.message)
  }).catch(function(err) {
    console.log(err)
  })
}

function contentBookMarking(){
  let articleId = $("button.btn-bookmark").data("article-id");
  articleId = isNaN(articleId)?0:Number(articleId);
  if (articleId <= 0) return;
  let url = `${rootUrl}/customer/bookmark/${articleId}`;
  axios({url:url,method:'GET'}).then(function(res) {
    if (res.data && res.data.status) {
      if (res.data.isBookmarked) {
        $("button.btn-bookmark").attr("data-is-marked", true);
        $("button.btn-bookmark").addClass("marked");
        $("button.btn-bookmark").children("span.txt").text($("button.btn-bookmark").data("bookmarked-txt"))
      } else {
        $("button.btn-bookmark").removeAttr("data-is-marked");
        $("button.btn-bookmark").removeClass("marked");
        $("button.btn-bookmark").children("span.txt").text($("button.btn-bookmark").data("bookmark-txt"))
      }
    }
    if (res.data && res.data.message) console.log(res.data.message)
  }).catch(function(err) {
    console.log(err)
  })
}

function loadContentProductList(){
  contentProductList();
  bindContentPagesEvents();
  getProductInfo();
  fixImgTitle();
  subscribeCssAttribute();
}

function loadContentPopup() {
  if (!window.location.href.split("/").includes("fakta-och-rad")) return;
  var userAgent = navigator.userAgent;
  var bots = ganBots;
  var isBot = false;
  for (var i in bots) {
    if (String(userAgent).indexOf(bots[i]) != -1) {
      isBot = true;
      break;
    }
  }
  if (isBot) return;
  let url=`/fakta-och-rad/showContentPopup`;
  axios({url:url,method:'GET'}).then(function(res) {
    if(res.data && res.data.status && res.data.html) {
      $('body').append(res.data.html);
      $("#contentPopupWrapper").fadeIn(500);
      bindingContentPopup();
    }
  }).catch(function(err){
    console.log(err);
  });
}

export {showAds, loadContentProductList,contentLabelsMarking, contentBookMarking, loadContentPopup};
